import $ from "jquery";
import { tns } from "tiny-slider";
import "./imports/salvattore.min.js";

$(document).ready(function () {
  // MENU TOGGLE
  $(".toggle-menu").on("click", function () {
    $("body").toggleClass("menu-open");
  });

  // SLIDER HERO
  var sliderHero = $(".hero__slider");
  sliderHero.each(function () {
    tns({
      container: this,
      items: 1,
      controls: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayButtonOutput: false,
      loop: true,
      mode: "gallery",
      speed: 2000,
    });
  });

  // SLIDER BILDER
  var sliderImages = $(".image-slider__items");
  sliderImages.each(function () {
    tns({
      container: this,
      speed: 500,
      items: 1,
      edgePadding: 100,
      controls: false,
      nav: false,
      gutter: 30,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayButtonOutput: false,
      loop: true,
      responsive: {
        501: {
          items: 2,
        },

        800: {
          items: 3,
        },

        1000: {
          gutter: 36,
          edgePadding: 100,
        },
        1280: {
          edgePadding: 250,
        },
      },
    });
  });

  // SLIDER ARTIKEL
  var sliderArticles = $(".article-slider__items");
  sliderArticles.each(function () {
    tns({
      container: this,
      speed: 500,
      controls: true,
      nav: false,
      loop: true,
      items: 1.5,
      gutter: 20,
      edgePadding: 20,
      responsive: {
        768: {
          center: true,
          items: 2,
          edgePadding: 0,
        },
      },
    });
  });

  // SLIDER LÖSUNGEN
  var sliderLoesungen = $(".slider-loesungen__items");
  sliderLoesungen.each(function () {
    tns({
      container: this,
      speed: 200,
      items: 1,
      controls: true,
      controlsContainer: "#slider-loesungen__controls",
      nav: false,
      autoplay: false,
      loop: false,
      mode: "gallery",
    });
  });

  // BLOG POSTS LOAD MORE
  $("[data-load-more]").on("click", function () {
    var button = $(this);
    var blogPosts = button.closest(".blog-posts");
    var category = blogPosts.find("[data-category-filter].is-active").data("category-filter");
    var posts = blogPosts.find(".blog-posts__item.is-hidden");

    if (category && category !== "all") {
      posts.filter(function () {
        return ($(this).data("categories") || "").split(" ").indexOf(category) !== -1;
      }).removeClass("is-hidden");
    } else {
      posts.removeClass("is-hidden");
    }
    button.parent().hide();
    blogPosts.data("expanded", true);
  });

  // BLOG POST CATEGORY FILTER
  $(".blog-posts").each(function () {
    var blogPosts = $(this);
    var filters = blogPosts.find("[data-category-filter]");
    var posts = blogPosts.find(".blog-posts__item");
    var loadMore = blogPosts.find("[data-load-more]").parent();

    filters.on("click", function () {
      var filter = $(this);
      var category = filter.data("category-filter");
      var matchingPosts = category === "all"
        ? posts
        : posts.filter(function () {
            return ($(this).data("categories") || "").split(" ").indexOf(category) !== -1;
          });

      filters.removeClass("is-active");
      filter.addClass("is-active");
      posts.addClass("is-hidden");
      if (blogPosts.data("expanded") === true) {
        matchingPosts.removeClass("is-hidden");
      } else {
        matchingPosts.slice(0, 9).removeClass("is-hidden");
      }
      loadMore.toggle(matchingPosts.length > 9 && blogPosts.data("expanded") !== true);
    });
  });

  // COPY ARTICLE LINK
  $("[data-copy-url]").on("click", function () {
    var button = $(this);
    var originalText = button.text();
    var url = button.data("copy-url");

    if (!navigator.clipboard || !url) {
      button.text("Kopieren nicht möglich");
      return;
    }

    navigator.clipboard.writeText(url).then(function () {
      button.text("Link kopiert");
      window.setTimeout(function () {
        button.text(originalText);
      }, 2000);
    }).catch(function () {
      button.text("Kopieren nicht möglich");
    });
  });

  ///// ACCORDION
  var acc = document.getElementsByClassName("is-accordion-trigger");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
});
